import { render, staticRenderFns } from "./MinBid.vue?vue&type=template&id=2f7fa254&"
import script from "./MinBid.vue?vue&type=script&lang=js&"
export * from "./MinBid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports